import { render, staticRenderFns } from "./buyOrderSearch.vue?vue&type=template&id=903c2284&scoped=true&"
import script from "./buyOrderSearch.vue?vue&type=script&lang=js&"
export * from "./buyOrderSearch.vue?vue&type=script&lang=js&"
import style0 from "./buyOrderSearch.vue?vue&type=style&index=0&id=903c2284&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "903c2284",
  null
  
)

export default component.exports